export const MARKETPLACE_ATTRIBUTION_COOKIE = "edx_mkt_attribution" as const;

export const MARKETPLACE_ATTRIBUTION_SESSION_KEY =
  "edx_mkt_attribution" as const;

export const MARKETPLACE_ATTRIBUTION_COOKIE_PATH = "/" as const;
